import customerItemEquivalencesServiceGen from "./generated/customerItemEquivalencesServiceGen";

class customerItemEquivalencesService extends customerItemEquivalencesServiceGen {
}

export default customerItemEquivalencesService;